import { HYPE_LIST } from '@racksavant/core';
import { Face, Plate } from './Photo';
import type { PlateId } from '../photos';
import s from './FittingRoom.module.css';

const PEOPLE = ['maya', 'jo', 'ava', 'tunde'] as const;

const CHAT = [
  { who: 'maya', said: 'the coat. the COAT.' },
  { who: 'jo', said: 'ok but try it in feral, i need to see it mean' },
] as const;

/**
 * A fitting room, faked honestly.
 *
 * Every reaction here is a real `HypeKind` from the shared taxonomy, and every
 * reaction is a photograph of somebody's face — the emoji chips are gone. The
 * faces are stuck on at an angle, they overlap each other, and none of them
 * sits inside a box.
 *
 * It carries no tallies and no headcount. This is an illustration of the shape
 * of a room, and an invented number in it would read as a measurement.
 */
export function FittingRoom({ plate = 'duo' }: { plate?: PlateId }) {
  return (
    <div className={s.room}>
      <div className={s.top}>
        <span className={s.code}>
          <span className={s.dot} aria-hidden="true" />
          Room · MIRRORBALL
        </span>
        <span className={s.presence}>
          {PEOPLE.join(', ')} · live
        </span>
      </div>

      <div className={s.stage}>
        <Plate id={plate} caption={false} className={s.plate} ratio={4 / 5} />

        <div className={s.stuck}>
          <Face kind="obsessed" size={92} tilt={-6} className={s.stickA} />
          <Face kind="menace" size={80} tilt={7} className={s.stickB} />
          <Face kind="crying" size={68} tilt={-3} className={s.stickC} />
        </div>

        <span className={s.stamp}>02:41 left</span>
      </div>

      <ul className={s.hypeRow}>
        {HYPE_LIST.map((h, i) => (
          <li key={h.kind} className={s.hype}>
            <Face kind={h.kind} size={54} tilt={i % 2 === 0 ? -4 : 4} labelled />
            <span className={s.hypeLabel}>{h.label}</span>
          </li>
        ))}
      </ul>

      <div className={s.chat}>
        {CHAT.map((line) => (
          <p key={line.who} className={s.line}>
            <span className={s.who}>{line.who}</span>
            <span className={s.said}>{line.said}</span>
          </p>
        ))}
        <p className={s.typing}>ava is typing</p>
      </div>
    </div>
  );
}
